import { MenuRoutes } from "./MenuRoutes";

export function getDefaultPage(user) {
  if (!user?.menus) return "/"; // fallback to login if no menus

  const allowedMenus = user.menus
    .split(",")
    .map((id) => parseInt(id.trim(), 10));

  // Pick the first allowed menu that exists in your mapping
  for (let menuId of allowedMenus) {
    if (MenuRoutes[menuId]) {
      return MenuRoutes[menuId];
    }
  }

  return "/";
}
